"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalize = void 0;
/**
 * Transforms a function that requires a single required (defined) argument into an equivalent function that allows an optional argument.
 * This is the equivalent of optional chained method calls but for free-functions.
 *
 * E.g:
 * ```typescript
 * // given:
 * const toString = (num: number) => num.toString();
 * const val: number | undefined: = ?
 *
 * // this:
 * optionalize(toString)(val);
 *
 * // is equivalent to:
 * val?.toString();
 * ```
 */
function optionalize(fn) {
    return (arg) => (arg === undefined ? undefined : fn(arg));
}
exports.optionalize = optionalize;
//# sourceMappingURL=optionalize.js.map